import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navigation from "./navigation/Navigation";
import Auth from "./features/auth/Auth";
import Register from "./features/usersmanagement/inviation/components/ConfigPassword"
import ForgotPassword from "./features/auth/components/ForgotPassword/ForgotPassword";
import ResetPassword from "./features/auth/components/ForgotPassword/ResetPassword";
import ProtectedRoute from "./navigation/ProtectedRoute";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import "./App.css";
import 'react-toastify/dist/ReactToastify.css';



const AppContent: React.FC = () => {
 

  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className=" min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

 return (
   <div className="App">
     <Routes>
      <Route path="/auth" element={<Auth />} />

       
<Route path="/config-password" element={<Register />} />
       <Route path="/forgot-password" element={<ForgotPassword />} />
         <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigation />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/accueil" replace />} />
          <Route path="accueil" element={<Navigation.DashboardPage />} />
          <Route path="utilisateurs" element={<Navigation.UserManagement />} />

<Route
  path="sites-web"
  element={
    <Navigation.GroupsPage
     />
  }
/>          
          <Route path="profile" element={<Navigation.ProfilePage />} />
         </Route>


       <Route
         path="/"
         element={<Navigate to="/auth" replace />}
       />
       <Route
         path="*"
         element={<Navigate to="/auth" replace />}
       />
     </Routes>
   </div>
 );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <AppContent />
          <ToastContainer position="top-right" />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;